import React from 'react'
import logo from '../assets/messageAvatar.svg'
import { useEffect } from 'react';
const LoadingDots = ({setDots}) => {

    useEffect(() => {
        // Set the state to true when loading dots are shown
        setDots(true);

        // Clean up the state when the component is unmounted or loading dots are hidden
        return () => {
            setDots(false);
        };
    }, [setDots]);

    return (
        <div className='flex gap-4'>
            <img width={40} src={logo} alt="" />
            <div className=''>
                <p>DELI</p>
                <div className="flex items-center py-2">
                    <div className="flex space-x-2 py-2 px-3 items-center">
                        <div className="w-1 h-1 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-1"></div>
                        <div className="w-1 h-1 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-2"></div>
                        <div className="w-1 h-1 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-3"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoadingDots